<template>
	<UPageFeature
		:title="item.title"
		:description="item.description"
		:icon="item.icon"
	/>
</template>

<script setup lang="ts">
import type { SectionItemFeature } from '@/types/components/section-item'

defineProps({
	item: {
		type: Object as PropType<SectionItemFeature>,
		required: true
	}
})
</script>
